// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateChileanDocument } from './chilean-document';
import { validateChileanPhoneNumber } from './chilean-phone-number';
import { validateChileanZipcode } from './chilean-zipcode';
import { validateChileanState } from './chilean-state';
import { validateChileanCity } from './chilean-city';
import { validateChileanAddress } from './chilean-address';
import { validateChileanStreetNumber } from './chilean-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);

  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'chileanDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_chilean_document') && validateChileanDocument(userInputValue);
      }
      return null;

    case 'chileanPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_chilean_phone_number') && validateChileanPhoneNumber(userInputValue);
      }
      return null;

    case 'chileanZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_chilean_zipcode') && validateChileanZipcode(userInputValue);
      }
      return null;

    case 'chileanState':
      if (!hasOptionalField(optionalFields, 'state')) {
        return onlyWhen('field_chilean_state') && validateChileanState(userInputValue);
      }
      return null;

    case 'chileanCity':
      if (!hasOptionalField(optionalFields, 'city')) {
        return onlyWhen('field_chilean_city') && validateChileanCity(userInputValue);
      }
      return null;

    case 'chileanAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_chilean_address') && validateChileanAddress(userInputValue);
      }
      return null;

    case 'chileanStreetNumber':
      if (!hasOptionalField(optionalFields, 'street_number')) {
        return onlyWhen('field_chilean_street_number') && validateChileanStreetNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
